<template>
  <div class="approval">
    <div class="reimbursement-approval-container">
      <div class="left-container">
        <type-tree 
          :list="list"
          :listId="departmentId"
          :type="type"
          @selectTreeNodeList="selectTreeNodeList"
        />
      </div>
      <div class="right-container" v-if="isNothing">
        <div class="top-container">
          <div class="tab">
            <div
              :class="activeIndex === index ? 'active tab-item' : 'tab-item'"
              v-for="(item, index) in procedureList"
              :key="index"
              @click="selectProcedure(item, index)"
            >
              {{ `${item.name}${index+1}` }}
            </div>
          </div>
          <div class="add">
            <el-button
            v-if="
              OPERATION_LIST.findIndex(
                (item) => item === OPERATIONS_BTNS.roleAddApproveSetting
              ) !== -1
            "
              type="text"
              class="btn-gray"
              icon="el-icon-plus"
              @click="add"
              >新增</el-button
            >
          </div>
        </div>
        <div v-if="billType !== 1" class="container">
          <div class="sub-title">发起审批</div>
          <div class="row">
            <div class="step">
              <div class="step-num">0</div>
              <div class="step-main step-main-agent">
                <div class="step-main-left step-main-agent-left">
                  <span class="step-main-agent-left-title">经办人：</span>
                  <span class="step-main-agent-left-content">{{ agent }}</span>
                </div>
                <div class="step-main-right step-main-agent-right" @click="setUp">设置</div>
              </div>
            </div>
          </div>
          <div class="sub-title">部门审批</div>
          <div
            class="row"
            v-for="(item, index) in agentDepartmentList"
            :key="index"
          >
            <div class="step">
              <div class="step-num" :class="{ active: !isSkip && index == 0 }">
                {{ index + 1 }}
              </div>
              <div class="step-main">
                <div
                  class="step-main-left"
                  :class="{ stepActive: !isSkip && index == 0 }"
                >
                  <span>
                    {{ item.title }}
                  </span>
                  <span>
                    {{ item.name }}
                  </span>
                </div>
                <div class="operation-btn">
                  <div
                    v-if="index == 0"
                    class="step-main-right"
                    @click="addDepartmentPeople"
                  >
                    新增
                  </div>
                  <div
                    v-if="isSkip && index == 0"
                    class="step-main-right"
                    @click="skip(1)"
                  >
                    跳过
                  </div>
                  <div
                    v-if="!isSkip && index == 0"
                    class="step-main-right"
                    @click="recovery(1)"
                  >
                    恢复
                  </div>
                  <div
                    v-if="index !== 0"
                    class="step-main-right"
                    @click="setDepartmentPeople(index)"
                  >
                    设置
                  </div>
                  <div
                    v-if="index !== 0"
                    class="step-main-right del"
                    @click="delDepartmentPeople(index)"
                  >
                    删除
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="step">
              <div :class="isSkip2 ? 'step-num' : 'active'">
                {{ agentDepartmentList.length + 1 }}
              </div>
              <div class="step-main">
                <div class="step-main-left" :class="{ stepActive: !isSkip2 }">
                  业务分管领导
                </div>
                <div v-if="isSkip2" class="step-main-right" @click="skip(2)">
                  跳过
                </div>
                <div v-else class="step-main-right" @click="recovery(2)">
                  恢复
                </div>
              </div>
            </div>
            <div class="financial-audit">
              <span class="financial-title">金额</span>
              <span>
                <el-input
                  :disabled="!isSkip2"
                  v-model="agentPrice"
                  class="gray white"
                  placeholder="请填写信息"
                  clearable
                >
                </el-input>
              </span>
            </div>
          </div>
          <div class="sub-title">财务审批</div>
          <div class="row">
            <div class="step">
              <div class="step-num">{{ agentDepartmentList.length + 2 }}</div>
              <div class="step-main">
                <div class="step-main-left">
                  财务审核人：{{ financialApproval }}
                </div>
              </div>
            </div>
            <div class="financial-audit">
              <span class="financial-title">审批人</span>
              <el-radio-group v-model="radio">
                <el-radio
                  v-for="(item, index) in financialAuditList"
                  :key="index"
                  :label="item.userId"
                  >{{ item.name }}</el-radio
                >
              </el-radio-group>
            </div>
          </div>
          <div class="row">
            <div class="step">
              <div :class="isSkip4 ? 'step-num' : 'active'">{{ agentDepartmentList.length + 3 }}</div>
              <div class="step-main">
                <div class="step-main-left" :class="{ stepActive: !isSkip4 }">
                  财务负责人
                </div>
                <div v-if="isSkip4" class="step-main-right" @click="skip(4)">
                  跳过
                </div>
                <div v-else class="step-main-right" @click="recovery(4)">
                  恢复
                </div>
              </div>
            </div>
          </div>
          <div class="sub-title">领导审批</div>
          <div class="row">
            <div class="step">
              <div :class="isSkip5 ? 'step-num' : 'active'">
                {{ agentDepartmentList.length + 4 }}
              </div>
              <div class="step-main">
                <div class="step-main-left" :class="{ stepActive: !isSkip5 }">
                  财务分管领导
                </div>
                <div v-if="isSkip5" class="step-main-right" @click="skip(5)">
                  跳过
                </div>
                <div v-else class="step-main-right" @click="recovery(5)">
                  恢复
                </div>
              </div>
            </div>
            <div class="financial-audit">
              <span class="financial-title">金额</span>
              <span>
                <el-input
                  :disabled="!isSkip5"
                  v-model="deputyLeaderPrice"
                  class="gray white"
                  placeholder="请填写信息"
                  clearable
                >
                </el-input>
              </span>
            </div>
            <!-- <div class="financial-audit" style="border-bottom: none;">
              <span class="financial-title">条件</span>
              <span>当分管副官拒绝审批时，审批流向财务审核人</span>
            </div>
            <div class="financial-audit">
              <span class="financial-title">审批人</span>
              <el-radio-group v-model="deputyLeaderRadio">
                <el-radio
                  :label="item.userId"
                  :disabled="!isSkip5"
                  v-for="(item, index) in deputyLeaderRadioList"
                  :key="index"
                  >{{ item.name }}</el-radio
                >
              </el-radio-group>
            </div> -->
          </div>
          <div class="row">
            <div class="step">
              <div :class="isSkip6 ? 'step-num' : 'active'">
                {{ agentDepartmentList.length + 5 }}
              </div>
              <div class="step-main">
                <div class="step-main-left" :class="{ stepActive: !isSkip6 }">
                  单位主官1：{{ centralLeader }}
                </div>
                <div class="operation-btn">
                  <div
                    class="step-main-right"
                    @click="setLeader(1)"
                  >
                    设置
                  </div>
                  <div v-if="isSkip6" class="step-main-right" @click="skip(6)">
                    跳过
                  </div>
                  <div v-else class="step-main-right" @click="recovery(6)">
                    恢复
                  </div>
                </div>
              </div>
            </div>
            <div class="financial-audit">
              <span class="financial-title">条件</span>
              <span>当分管主官拒绝审批时，审批流向财务审核人</span>
            </div>
            <div class="financial-audit">
              <span class="financial-title">金额</span>
              <span>
                <el-input
                  :disabled="!isSkip6"
                  v-model="centralLeaderPrice"
                  class="gray white"
                  placeholder="请填写信息"
                  clearable
                >
                </el-input>
              </span>
            </div>
          </div>
          <div class="row">
            <div class="step">
              <div class="step-num-default">
                <!-- {{ agentDepartmentList.length + 6 }} -->
              </div>
              <div class="step-main">
                <div class="step-main-left" :class="{ stepActive: !isSkip7 }">
                  单位主官2：{{ centralLeaderTwo }}
                </div>
                <div class="operation-btn">
                  <div
                    class="step-main-right"
                    @click="setLeader(2)"
                  >
                    设置
                  </div>
                  <div v-if="isSkip7" class="step-main-right" @click="skip(7)">
                    跳过
                  </div>
                  <div v-else class="step-main-right" @click="recovery(7)">
                    恢复
                  </div>
                </div>
              </div>
            </div>
            <div class="financial-audit">
              <span class="financial-title">条件</span>
              <span>当分管主官拒绝审批时，审批流向财务审核人</span>
            </div>
            <div class="financial-audit">
              <span class="financial-title">金额</span>
              <span>
                <el-input
                  :disabled="!isSkip7"
                  v-model="centralLeaderPriceTwo"
                  class="gray white"
                  placeholder="请填写信息"
                  clearable
                >
                </el-input>
              </span>
            </div>
          </div>
          <div class="sub-title">其他设置</div>
          <p class="condition">上会前置条件</p>
          <div class="condition-row">
            <span>金额</span>
            <el-input
              class="gray white"
              placeholder="请填写信息"
              v-model="price"
              clearable
            >
            </el-input>
          </div>
        </div>
        <!-- 出差审批单流程 -->
        <div class="container" v-else>
          <div class="sub-title">适用部门</div>
          <div class="row">
            <div class="step">
              <div class="step-main">
                <div class="step-main-left">适用：{{ suitDepartment }}</div>
                <div class="step-main-right" @click="setUp">设置</div>
              </div>
            </div>
          </div>
          <div class="evection" v-for="(item, index) in evectionList" :key="index">
            <div class="sub-title evection-title">
              <p>角色{{index+1}}</p>
            </div>
            <div class="evection-row">
              <div class="evection-row-container">
                <div class="evection-agent">经办人</div>
                <div class="evection-row-content">
                  <img class="evection-img" src="../assets/department-avater.png">
                  <p>{{ item.agent }}</p>
                </div>
              </div>
              <div class="evection-row-approval" v-for="(v, idx) in item.children" :key="idx">
                <div class="evection-row-center">
                  <i class="el-icon-right"></i>
                </div>
                <div class="evection-row-approval-content">
                  <div class="evection-agent">审批人</div>
                  <div class="evection-row-content">
                    <img class="evection-img" src="../assets/department-avater.png">
                    <p>{{ v.approval }}</p>
                  </div>
                  <i class="el-icon-error" @click="removeEvectionApproval(item.children, idx)"></i>
                </div>
              </div>
              <div v-if="item.children.length < 3" class="evection-row-center">
                <i class="el-icon-right"></i>
              </div>
              <i v-if="item.children.length < 3" class="el-icon-circle-plus-outline" @click="addEvectionApproval(index)"></i>
            </div>
          </div>
        </div>
        <div class="foot-container"
          v-if="
            OPERATION_LIST.findIndex(
              (item) => item === OPERATIONS_BTNS.roleUpdateApproveSetting
            ) !== -1
          "
        >
          <el-button
            class="btn-blue" type="primary" @click="save"
            >保存</el-button
          >
          <el-button class="btn-border-text-red" type="primary" @click="delProcedure"
            >删除</el-button
          >
        </div>
      </div>
      <div v-else class="nothing">
        <div>
          <div>
            <img src="../assets/nothing.png">
          </div>
          <p>暂无数据</p>
        </div>
      </div>
    </div>

    <!-- 选择部门 -->
    <department-dialog
      :departmentDialog="departmentDialog"
      :isFlag="isFlag"
      :keyword="'reimburse'"
      @oPenOrCloseDepartmentDialog="oPenOrCloseDepartmentDialog"
      @submitSelectData="submitSelectData"
    ></department-dialog>

    <!-- 选择部门负责人 -->
    <el-dialog
      title="选择部门负责人"
      :visible.sync="dialogVisible"
      width="540px"
      :before-close="handleClose"
    >
      <div class="dialog-content">
        <div
          :class="
            departmentActiveIndex === index
              ? 'departmentActive department-people'
              : 'department-people'
          "
          v-for="(item, index) in departmentPeopleList"
          :key="index"
          @click="selectDepartmentPeople(item, index)"
        >
          {{ item.name }}
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="confrimDepartment">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 选择出差审批单审批人角色 -->
    <el-dialog
      title="添加审批人"
      :visible.sync="dialogSelectApprovalVisible"
      width="540px"
      :before-close="handleSelectApprovalClose"
    >
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="选择审批人" prop="approval">
          <el-select
            v-model="form.approval"
            placeholder="请选择"
            class="gray white"
          >
            <el-option
              v-for="item in evectionApprovalList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleSelectApprovalClose">取 消</el-button>
        <el-button type="primary" @click="confirm('form')">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 选择主官 -->
    <el-dialog
      title="选择主官"
      :visible.sync="dialogLeaderVisible"
      width="540px"
      :before-close="handleLeaderClose"
    >
      <div class="dialog-content">
        <div
          :class="
            leaderActiveIndex === index
              ? 'departmentActive department-people'
              : 'department-people'
          "
          v-for="(item, index) in centralLeaderList"
          :key="index"
          @click="selectLeader(item, index)"
        >
          {{ item.name }}
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleLeaderClose">取 消</el-button>
        <el-button type="primary" @click="confirmLeader">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import TypeTree from "@/components/type-tree.vue";
import DepartmentDialog from "@/components/department-dialog.vue";
import { operationMixins } from '@/common/mixins/operation/operation.js'
import { handleAmount, mapId, mapId4} from "@/common/js/utils.js";
import BillAdmin from "@/models/bill-admin.js";
import Approval from "@/models/approval.js";
export default {
  mixins: [operationMixins],
  props: {
    departmentId: {
      type: Number,
    },
    isBillType: {
      type: Number,
    },
  },

  components: {
    TypeTree,
    DepartmentDialog,
  },

  data() {
    return {
      // 1.报销单
      isBillTypeCopy: this.isBillType,
      id: '', // 单据id
      isNothing: false,
      type: 3,
      list: [],
      isSwitchImg: false,
      typeId: '',
      activeIndex: 0,
      procedureList: [
        {name: '流程'}
      ],
      agent: "",
      agentId: [],
      procedureId: null,          // 流程id
      financialApproval: "",
      radio: null,
      financialAuditList: [],
      // deputyLeaderRadio: null,
      deputyLeaderRadioList: [],
      // deputyLeader: "",
      
      // 单位主官类型
      leaderType: null,
      // 单位主官列表
      centralLeaderList: [],
      // 单位主官1
      centralLeader: "",
      // 单位主官2
      centralLeaderTwo: "",
      price: "",
      isSkip: true,
      isSkip2: true,
      isSkip4: true,
      isSkip5: true,
      isSkip6: true,
      isSkip7: true,
      agentDepartmentList: [
        {
          title: "经办人部门负责人",
          name: "",
          userId: ''
        },
      ],
      deputyLeaderPrice: '',
      agentPrice: '',
      // 单位主官1金额
      centralLeaderPrice: '',
      // 单位主官2金额
      centralLeaderPriceTwo: '',
      /* 记录部门负责人下标 */
      departmentPeopleIndex: null,
      billType: 2, // 1. 出差审批单
      thirdDeptList: [],
      officialType: '',

      /* ----------------- 以下是选择主官 ----------------- */
      leaderActiveIndex: null,
      dialogLeaderVisible: false,
      leaderObj: null,
      
      /* ----------------- 以下是选择部门成员 ----------------- */
      departmentPeopleList: [],
      departmentActiveIndex: null,
      dialogVisible: false,
      isFlag: 2,
      departmentPeopleObj: null,

      /* -------------------- 以下是选择部门字段 -------------------- */
      departmentDialog: false,

      /* -------------------- 以下是出差审批单字段 ------------------ */
      suitDepartment: null,
      evectionList: [
        {type: 1, agent: '普通用户', roleType: 0,children: []},
        {type: 2, agent: '部门负责人', roleType: 1,children: []},
        {type: 3, agent: '业务分管领导', roleType: 2,children: []},
        {type: 4, agent: '单位主官', roleType: 6,children: []},
      ],
      form: {
        approval: "",
      },
      rules: {
        approval: [{ required: true, message: "请选择审批人", trigger: "change" }],
      },
      evectionApprovalList: [
        {id:1, name: '部门负责人'},
        {id:2, name: '业务分管领导'},
        {id:6, name: '单位主官'}
      ],
      evectionApprovalTypeObj: {
        1: '部门负责人',
        2: '业务分管领导',
        6: '单位主官',
      },
      dialogSelectApprovalVisible: false,
      evectionIndex: ''
    };
  },

  created() {
    if (this.isBillTypeCopy == 1) {
      this.type = 3
      this.initDepartmentList()
    } else {
      this.type = 4
      this.initPreliminaryTypeList()
    }
    this.id = this.$route.query.formId
    if (this.id) {
      this.isNothing = true
      this.isBillTypeCopy = this.$route.query.depId
      this.typeId = this.$route.query.billType
      this.officialType = this.$route.query.officialType
      if (this.officialType == 'BizTripTrial') {
        this.billType = 1
        this._getEvectionDetails()
      } else {
        this.billType = 2
        this.getDetails()
      }
    }
  },

  methods: {
    /* 获取报销单类型 */
    initDepartmentList() {
      let queryStr = ''
      BillAdmin.getReimbursementTypeList(queryStr).then(res => {
        if (res.success) {
          let arr = this.mapChild(res.result);
          this.list = mapId4(arr, this.departmentId)
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    mapChild(child, id) {
      let arr = [];
      child.map((value) => {
        let obj = {};
        obj.id = value.id;
        obj.typeId = id?id:value.id;
        obj.label = value.name;
        obj.level = value.level;
        if (value.reimburseFormList && value.reimburseFormList.length > 0) {
          obj.children = this.mapChild(value.reimburseFormList, value.id);
        } else {
          obj.children = [];
        }
        arr.push(obj);
      });
      return arr;
    },

    /* 获取预审批单类型 */
    initPreliminaryTypeList() {
      let queryStr = ''
      BillAdmin.getPreliminaryTypeList(queryStr).then(res => {
        if (res.success) {
          let arr = this.mapChild2(res.result);
          this.list = mapId(arr, this.departmentId)
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    mapChild2(child, id) {
      let arr = [];
      child.map((value) => {
        let obj = {};
        obj.id = value.id;
        obj.typeId = id?id:value.id;
        obj.label = value.name;
        obj.level = value.level;
        obj.officialType = value.systemPreset;
        obj.identification = value.identification
        if (value.subList && value.subList.length > 0 && value.level == 1) {
          obj.children = this.mapChild2(value.subList);
        } else {
          if (value.preApprovalFormList && value.preApprovalFormList.length > 0) {
            obj.children = this.mapChild2(value.preApprovalFormList, value.id);
          } else {
            obj.children = [];
          }
        }
        arr.push(obj);
      });
      return arr;
    },

    /* 根据id获取所有的角色成员 */
    initAllRoleStaff(roleType) {
      let deptId = this.agentId.length > 0?this.agentId[0].deptId: ''
      let searchFlag = 1
      Approval.postIdAllRoleStaff(roleType, deptId, searchFlag).then(res => {
        if (res.success) {
          let departmentPeopleList = []
          let financialAuditList = []
          let deputyLeaderRadioList = []
          let centralLeaderList = []
          let arr = []
          let arr2 = []
          res.result.map(i => {
            if (roleType == 1) {
              let departmentPeopleObj = {}
              departmentPeopleObj.userId = i.userId
              let deptName = i.deptName ? `(${i.deptName})` : ''
              departmentPeopleObj.name = `${i.userName}${deptName}`
              departmentPeopleList.push(departmentPeopleObj)
            }
            if (roleType == 3) {
              let financialAuditObj = {}
              financialAuditObj.userId = i.userId
              financialAuditObj.name = i.userName
              financialAuditList.push(financialAuditObj)
              arr.push(i.userName)
            }
            if (roleType == 5) {
              let deputyLeaderRadioObj = {}
              deputyLeaderRadioObj.userId = i.userId
              deputyLeaderRadioObj.name = i.userName
              deputyLeaderRadioList.push(deputyLeaderRadioObj)
              arr2.push(i.userName)
            }
            if (roleType == 6) {
              let leaderObj = {}
              leaderObj.name = i.userName
              leaderObj.userId = i.userId
              centralLeaderList.push(leaderObj)
            }
          })
          if (roleType == 1) this.departmentPeopleList = departmentPeopleList
          if (roleType == 3) {
            this.financialAuditList = financialAuditList
            if(!this.radio) this.radio = this.financialAuditList.length > 0 ?this.financialAuditList[0].userId : ''
            this.financialApproval = arr.join('；')
          }
          if (roleType == 5) {
            this.deputyLeaderRadioList = deputyLeaderRadioList
          }
          if (roleType == 6) this.centralLeaderList = centralLeaderList
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    /* 获取该3级部门下部门负责人 */
    initDepartmentPeopleRoleStaff(roleType) {
      this.initAllRoleStaff(roleType)
    },
    
    /* 获取该3级部门下财务审核人 */
    initFinancialAuditListRoleStaff(roleType) {
      this.initAllRoleStaff(roleType)
    },

    /* 获取该3级部门下单位主官 */
    initCentralLeaderRoleStaff(roleType) {
      this.initAllRoleStaff(roleType)
    },

    /* 获取流程详情 */
    getDetails() {
      let type = this.isBillTypeCopy
      let typeId = this.typeId
      let formId = this.id
      Approval.getDetails(type, typeId, formId).then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.name = '流程'
            obj.procedureId = i.id
            obj.typeId = i.typeId
            obj.formId = i.formId
            obj.subLimit = handleAmount(i.subLimit,2)
            obj.agentId = []
            obj.agent = []
            obj.thirdDeptList = []
            i.approveSettingDepartmentRelateVoList.map(v => {
              let obj2 = {}
              let obj3 = {}
              obj3.id = v.deptId
              obj3.departmentName = v.deptName
              obj3.id2 = v.deptId
              obj2.deptId = v.deptId
              obj.agentId.push(obj2)
              obj.agent.push(v.deptName)
              obj.thirdDeptList.push(obj3)
            })
            obj.agentDepartmentList = []
            i.approveSettingDetailVoList.map((item, index) => {
              if (item.roleType == 1) {
                let obj3 = {}
                obj3.title = '经办人部门负责人'
                obj3.name = ''
                obj3.userId = item.userId
                obj.agentDepartmentList.push(obj3)
                obj.isSkip = item.isContinue == 1 ? false : true
              }
              if (item.roleType == 12) {
                let obj3 = {}
                obj3.name = item.userName
                obj3.title = '部门负责人'
                obj3.userId = item.userId
                obj.agentDepartmentList.push(obj3)
              }
              if (item.roleType == 2) {
                obj.agentPrice = handleAmount(item.baseAmount,2)
                obj.isSkip2 = item.isContinue == 1 ? false : true
              }
              if (item.roleType == 3) {
                obj.radio = item.userId
              }
              if (item.roleType == 4) {
                obj.isSkip4 = item.isContinue == 1 ? false : true
              }
              if (item.roleType == 5) {
                // obj.deputyLeaderRadio = item.userId
                obj.deputyLeaderPrice = handleAmount(item.baseAmount,2)
                obj.isSkip5 = item.isContinue == 1 ? false : true
              }
              if (item.roleType == 6) {
                if (i.approveSettingDetailVoList.length == (index+1)) {
                  // 单位主官2
                  obj.centralLeaderPriceTwo = handleAmount(item.baseAmount,2)
                  obj.isSkip7 = item.isContinue == 1 ? false : true
                  obj.centralLeaderTwoId = item.userId
                  obj.centralLeaderTwo = item.userName
                } else {
                  // 单位主官1
                  obj.centralLeaderPrice = handleAmount(item.baseAmount,2)
                  obj.isSkip6 = item.isContinue == 1 ? false : true
                  obj.centralLeaderId = item.userId
                  obj.centralLeader = item.userName
                }
              }
            })
            arr.push(obj)
          })
          this.procedureList = arr
          if (this.procedureList.length > 0) {
            this.agentDepartmentList = this.procedureList[this.activeIndex].agentDepartmentList
            this.procedureId = this.procedureList[this.activeIndex].procedureId
            this.price = this.procedureList[this.activeIndex].subLimit
            this.isSkip = this.procedureList[this.activeIndex].isSkip
            this.isSkip2 = this.procedureList[this.activeIndex].isSkip2
            this.isSkip4 = this.procedureList[this.activeIndex].isSkip4
            this.isSkip5 = this.procedureList[this.activeIndex].isSkip5
            this.isSkip6 = this.procedureList[this.activeIndex].isSkip6
            this.isSkip7 = this.procedureList[this.activeIndex].isSkip7
            this.centralLeader = this.procedureList[this.activeIndex].centralLeader
            this.centralLeaderTwo = this.procedureList[this.activeIndex].centralLeaderTwo
            this.radio = this.procedureList[this.activeIndex].radio
            this.deputyLeaderPrice = this.procedureList[this.activeIndex].deputyLeaderPrice
            this.centralLeaderPrice = this.procedureList[this.activeIndex].centralLeaderPrice
            this.centralLeaderPriceTwo = this.procedureList[this.activeIndex].centralLeaderPriceTwo
            this.agentPrice = this.procedureList[this.activeIndex].agentPrice
            // this.deputyLeaderRadio = this.procedureList[0].deputyLeaderRadio
            this.agentId = this.procedureList[this.activeIndex].agentId
            this.agent = this.procedureList[this.activeIndex].agent.join('；')
            this.thirdDeptList = this.procedureList[this.activeIndex].thirdDeptList
            this.initDepartmentPeopleRoleStaff(1)
            this.initFinancialAuditListRoleStaff(3)
            this.initCentralLeaderRoleStaff(6)
          } else {
            this.procedureList = [{name: '流程'}]
            // this.procedureId = ''
            // this.agentId = ''
            // this.agent = ''
            // this.thirdDeptList = []
            this.clearDate()
          }
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    /* 获取出差审批单流程详情 */
    _getEvectionDetails() {
      Approval.getEvectionDetails().then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.name = '流程'
            obj.procedureId = i.approveSettingId
            obj.agentId = []
            obj.agent = []
            obj.thirdDeptList = []
            i.thirdDeptList.map(v => {
              let obj3 = {}
              let obj2 = {}
              obj2.deptId = v.deptId
              obj3.id = v.deptId
              obj3.departmentName = v.deptName
              obj.agentId.push(obj2)
              obj.agent.push(v.deptName)
              obj.thirdDeptList.push(obj3)
            })
            obj.evectionList = []
            i.approveNodeList.map(val => {
              let evectionObj = {}
              evectionObj.children = []
              val.entityList.map((item, index) => {
                if (index > 0) {
                  let evectionChildrenObj = {}
                  evectionChildrenObj.approval = item.roleName
                  evectionChildrenObj.roleType = item.roleType
                  evectionObj.children.push(evectionChildrenObj)
                } else {
                  evectionObj.type = val.type
                  evectionObj.agent = item.roleName
                  evectionObj.roleType = item.roleType
                }
              })
              obj.evectionList.push(evectionObj)
            })
            arr.push(obj)
          })
          if (arr.length == 0) {
            this.procedureList = [
              {name: '流程'}
            ]
            this.procedureId = ''
            this.agentId = ''
            this.suitDepartment = null,
            this.evectionList = [
              {type: 1, agent: '普通用户', roleType: 0,children: []},
              {type: 2, agent: '部门负责人', roleType: 1,children: []},
              {type: 3, agent: '业务分管领导', roleType: 2,children: []},
              {type: 4, agent: '单位主官', roleType: 6,children: []}
            ]
            this.thirdDeptList = []
          } else {
            this.procedureList = arr
            this.procedureId = this.procedureList[this.activeIndex].procedureId
            this.agentId = this.procedureList[this.activeIndex].agentId
            this.suitDepartment = this.procedureList[this.activeIndex].agent.join('；')
            this.evectionList = this.procedureList[this.activeIndex].evectionList
            this.thirdDeptList = this.procedureList[this.activeIndex].thirdDeptList
          }
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    /* 新增流程 */
    add() {
      let obj = {
        name: '流程'
      }
      this.procedureList.push(obj)
      this.activeIndex = this.procedureList.length-1
      this.selectProcedure(obj, this.activeIndex)
    },

    selectTreeNodeList(v) {
      this.id = v.id
      this.typeId = v.typeId
      this.activeIndex = 0
      this.clearDate()
      if (v.identification == 'BizTripTrial') {
        this.billType = 1
        this.isFlag = 1
        this.clearDate()
        this.$bus.emit('init', this.isFlag)
        if (v.children.length == 0) {
          this.isNothing = true
          this._getEvectionDetails()
        } else {
          this.isNothing = false
        }
      } else {
        this.billType = 2
        this.isFlag = 2
        this.$bus.emit('init', this.isFlag)
        if (this.isBillTypeCopy == 1) {
          if (v.level == 2) {
            this.isNothing = true
            this.getDetails()
          } else {
            this.isNothing = false
          }
        } else {
          if (v.children.length == 0) {
            this.isNothing = true
            this.getDetails()
          } else {
            this.isNothing = false
          }
        }
      }
      
    },

    /* 选择流程 */
    selectProcedure(item, index) {
      this.activeIndex = index;
      if (item.procedureId) {
        if (this.billType == 2) {
          this.agentDepartmentList = item.agentDepartmentList
          this.procedureId = item.procedureId
          this.price = item.subLimit
          this.isSkip = item.isSkip
          this.isSkip2 = item.isSkip2
          this.isSkip4 = item.isSkip4
          this.isSkip5 = item.isSkip5
          this.isSkip6 = item.isSkip6
          this.isSkip7 = item.isSkip7
          this.centralLeader = item.centralLeader
          this.centralLeaderTwo = item.centralLeaderTwo
          this.radio = item.radio
          this.agentId = item.agentId
          this.agent = item.agent.join('；')
          this.thirdDeptList = item.thirdDeptList
          this.deputyLeaderPrice = item.deputyLeaderPrice
          this.centralLeaderPrice = item.centralLeaderPrice
          this.centralLeaderPriceTwo = item.centralLeaderPriceTwo
          this.agentPrice = item.agentPrice
        } else {
          this.agentId = item.agentId
          this.suitDepartment = item.agent.join('；')
          this.evectionList = item.evectionList
          this.procedureId = item.procedureId
          this.thirdDeptList = item.thirdDeptList
        }
        this.initDepartmentPeopleRoleStaff(1)
        this.initFinancialAuditListRoleStaff(3)
        this.initCentralLeaderRoleStaff(6)
      } else {
        if (this.billType == 1) {
          this.evectionList = [
            {type: 1, agent: '普通用户', roleType: 0,children: []},
            {type: 2, agent: '部门负责人', roleType: 1,children: []},
            {type: 3, agent: '业务分管领导', roleType: 2,children: []},
            {type: 4, agent: '单位主官', roleType: 6,children: []},
          ]
        }
        this.clearDate()
      }
    },

    /* 清空数据 */
    clearDate() {
      this.radio = this.financialAuditList.length > 0 ? this.financialAuditList[0].userId : ''
      // this.deputyLeaderRadio = this.deputyLeaderRadioList.length > 0 ? this.deputyLeaderRadioList[0].userId : ''
      this.agentDepartmentList = [
        {
          title: "经办人部门负责人",
          name: "",
          userId: ''
        },
      ]
      this.procedureId = null
      this.price = ""
      this.deputyLeaderPrice = ''
      this.centralLeaderPrice = ''
      this.centralLeaderPriceTwo = ''
      this.centralLeader = ''
      this.centralLeaderTwo = ''
      this.agentPrice = ''
      this.isSkip = true
      this.isSkip2 = true
      this.isSkip4 = true
      this.isSkip5 = true
      this.isSkip6 = true
      this.isSkip7 = true
      this.agent = ''
      this.agentId = []
      this.thirdDeptList = []
      this.suitDepartment = ''
    },

    /* 跳过 */
    skip(v) {
      if (v == 1) {
        this.isSkip = false;
      } else if (v == 2) {
        this.isSkip2 = false;
      } else if (v == 4) {
        this.isSkip4 = false;
      } else if (v == 5) {
        this.isSkip5 = false;
      } else if (v == 6) {
        this.isSkip6 = false;
      } else if (v == 7) {
        this.isSkip7 = false;
      }
    },

    /* 恢复 */
    recovery(v) {
      if (v == 1) {
        this.isSkip = true;
      } else if (v == 2) {
        this.isSkip2 = true;
      }  else if (v == 4) {
        this.isSkip4 = true;
      } else if (v == 5) {
        this.isSkip5 = true;
      } else if (v == 6) {
        this.isSkip6 = true;
      } else if (v == 7) {
        this.isSkip7 = true;
      }
    },

    save() {
      if (this.billType == 2) {
        let type = this.isBillTypeCopy
        let typeId = this.typeId
        let formId = this.id
        let subLimit = handleAmount(this.price,1)
        let deputyLeaderPrice = handleAmount(this.deputyLeaderPrice,1)
        let centralLeaderPrice = 0
        if (this.centralLeaderPrice) {
          centralLeaderPrice = handleAmount(this.centralLeaderPrice,1)
        }
        let centralLeaderPriceTwo = 0
        if (this.centralLeaderPriceTwo) {
          centralLeaderPriceTwo = handleAmount(this.centralLeaderPriceTwo,1)
        }
        let agentPrice = handleAmount(this.agentPrice,1)
        let centralLeaderId = 0
        let centralLeaderTwoId = 0
        if (this.procedureList[this.activeIndex].centralLeaderId) {
          centralLeaderId = this.procedureList[this.activeIndex].centralLeaderId
        }
        if (this.procedureList[this.activeIndex].centralLeaderTwoId) {
          centralLeaderTwoId = this.procedureList[this.activeIndex].centralLeaderTwoId
        }
        if (this.isSkip6 && centralLeaderId == 0) {
          return this.$message.error('请选择单位主官1')
        }
        if (this.isSkip7 && centralLeaderTwoId == 0) {
          return this.$message.error('请选择单位主官2')
        }
        let approveSettingDetailVoList = [
          {'isContinue': this.isSkip2?0:1, 'roleType': 2, 'baseAmount': agentPrice  },
          {'isContinue': 0, 'roleType': 3, userId: this.radio },
          {'isContinue': this.isSkip4?0:1, 'roleType': 4 },
          {'isContinue': this.isSkip5?0:1, 'roleType': 5, 'baseAmount': deputyLeaderPrice },
          {'isContinue': this.isSkip6?0:1, 'roleType': 6, 'baseAmount': centralLeaderPrice, userId: centralLeaderId },
          {'isContinue': this.isSkip7?0:1, 'roleType': 6, 'baseAmount': centralLeaderPriceTwo, userId: centralLeaderTwoId },
        ]
        let isAgentDepartmentUserId = false
        for(let i = this.agentDepartmentList.length - 1; i >= 0; i-- ) {
          let obj = {}
          obj.isContinue = this.isSkip?0:1
          obj.roleType = 1
          if (i > 0) {
            obj.isContinue = 0
            obj.userId = this.agentDepartmentList[i].userId
            obj.roleType = 12
            if(!obj.userId) {
              isAgentDepartmentUserId = true
            }
          }
          approveSettingDetailVoList.unshift(obj)
        }
        
        if (isAgentDepartmentUserId) {
          return this.$message.error('请选择部门负责人')
        }
        
        let approveSettingDepartmentRelateVoList = this.agentId
        let data = {
          type,
          typeId,
          formId,
          subLimit,
          approveSettingDetailVoList,
          approveSettingDepartmentRelateVoList
        }
        if (this.procedureId) {
          data.id = this.procedureId
          Approval.postModApproval(data).then(res => {
            if (res.success) {
              this.$message({
                type: 'success',
                message: '修改成功'
              });
              this.getDetails()
            } else {
              this.$message({
                type: 'error',
                message: res.message
              });
            }
          })
        } else {
          Approval.postAddApproval(data).then(res => {
            if (res.success) {
              this.$message({
                type: 'success',
                message: '新增成功'
              });
              this.getDetails()
            } else {
              this.$message({
                type: 'error',
                message: res.message
              });
            }
          })
        }
      } else {
        let data = {}
        let agentId = []
        this.agentId.map(i => {
          agentId.push(i.deptId)
        })
        if (agentId.length == 0) {
          this.$message({
            type: 'error',
            message: '请设置适用部门'
          });
          return
        }
        data.thirdDeptIdList = agentId
        data.settingDetailList = []
        this.evectionList.map(i => {
          let obj = {}
          let obj3 = {}
          obj.type = i.type
          obj3.roleType = i.roleType
          obj3.sort = 1
          obj.entityList = []
          obj.entityList.push(obj3)
          i.children.map((v, index) => {
            let obj2 = {}
            obj2.roleType = v.roleType
            obj2.sort = index+2
            obj.entityList.push(obj2)
          })
          data.settingDetailList.push(obj)
        })
        if (this.procedureId) {
          data.id = this.procedureId
          Approval.postModEvectionApproval(data).then(res => {
            if (res.success) {
              this.$message({
                type: 'success',
                message: '修改成功'
              });
              this._getEvectionDetails()
            } else {
              this.$message({
                type: 'error',
                message: res.message
              });
            }
          })
        } else {
          Approval.postAddEvectionApproval(data).then(res => {
            if (res.success) {
              this.$message({
                type: 'success',
                message: '新增成功'
              });
              this._getEvectionDetails()
            } else {
              this.$message({
                type: 'error',
                message: res.message
              });
            }
          })
        }
      }
    },

    delProcedure() {
      this.$confirm("流程删除后不可恢复，是否继续？", "确认删除流程", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        confirmButtonClass: 'btn-red',
        cancelButtonClass: 'btn-gray'
      }).then(() => {
        let data = {
          id: this.procedureId
        }
        Approval.postDelProcedure(data).then(res => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '删除流程成功'
            });
            
            if (this.activeIndex>0) this.activeIndex--
            if (this.billType == 2) {
              this.getDetails()
            } else {
              this._getEvectionDetails()
            }
          } else {
            this.$message({
              type: 'error',
              message: res.message
            });
          }
        })
      });
    },

    /* 新增部门负责人 */
    addDepartmentPeople() {
      this.agentDepartmentList.push({ title: "部门负责人", name: "", userId: '' });
    },

    /* 删除部门负责人 */
    delDepartmentPeople(index) {
      this.agentDepartmentList.splice(index, 1);
    },

    /* 设置部门负责人 */
    setDepartmentPeople(index) {
      this.departmentPeopleIndex = index
      this.dialogVisible = true
    },

    selectDepartmentPeople(row, index) {
      this.departmentPeopleObj = row
      this.departmentActiveIndex = index
    },

    confrimDepartment() {
      this.agentDepartmentList[this.departmentPeopleIndex].name = this.departmentPeopleObj.name
      this.agentDepartmentList[this.departmentPeopleIndex].userId = this.departmentPeopleObj.userId
      this.handleClose()
    },

    handleClose() {
      this.departmentPeopleObj = null
      this.departmentActiveIndex = null
      this.dialogVisible = false
    },

    /** 
     * @params type 1:单位主官1; 2：单位主官2
    */
    setLeader(type) {
      this.leaderType = type
      this.dialogLeaderVisible = true
    },

    selectLeader(row, index) {
      this.leaderObj = row
      this.leaderActiveIndex = index
    },

    confirmLeader() {
      if (this.leaderType == 1) {
        this.centralLeader = this.leaderObj.name
        this.procedureList[this.activeIndex].centralLeader = this.leaderObj.name
        this.procedureList[this.activeIndex].centralLeaderId = this.leaderObj.userId
      } else {
        this.centralLeaderTwo = this.leaderObj.name
        this.procedureList[this.activeIndex].centralLeaderTwo = this.leaderObj.name
        this.procedureList[this.activeIndex].centralLeaderTwoId = this.leaderObj.userId
      }
      this.handleLeaderClose()
    },

    handleLeaderClose() {
      this.leaderObj = null
      this.leaderActiveIndex = null
      this.dialogLeaderVisible = false
    },

    /* -------------------  以下是选择部门方法  --------------------- */
    setUp() {
      this.departmentDialog = true;
      this.$bus.emit('initSelectDepartment', this.thirdDeptList)
    },

    /* 关闭部门弹窗 */
    oPenOrCloseDepartmentDialog(data) {
      this.departmentDialog = data;
    },

    /* 确定部门弹窗 */
    submitSelectData(data) {
      let arr = []
      let arr2 = []
      data.map(i => {
        let obj = {}
        obj.deptId = i.id2
        arr.push(obj)
        arr2.push(i.departmentName)
      })
      if (this.billType == 1) {
        this.suitDepartment = arr2.join('；')
      } else {
        this.agent = arr2.join('；')
      }
      this.agentId = arr
      this.oPenOrCloseDepartmentDialog(false);
      this.initDepartmentPeopleRoleStaff(1)
      this.initFinancialAuditListRoleStaff(3)
      this.initCentralLeaderRoleStaff(6)
    },

    /* ------------------ 以下是出差审批单页面 -------------- */
    /* 添加出差审批单审批人角色 */
    addEvectionApproval(index) {
      this.evectionIndex = index
      this.dialogSelectApprovalVisible = true
    },

    handleSelectApprovalClose() {
      this.dialogSelectApprovalVisible = false
      this.form.approval = ''
    },
    
    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let obj = {
            roleType: this.form.approval,
            approval: this.evectionApprovalTypeObj[this.form.approval]
          }
          this.evectionList[this.evectionIndex].children.push(obj)
          this.handleSelectApprovalClose()
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    removeEvectionApproval(row, idx) {
      row.splice(idx,1)
    }
  },
};
</script>

<style lang='scss'>
.approval {
  flex: 1;
  background: $bg-white;
  .reimbursement-approval-container {
    height: 100%;
    display: flex;
  }
  .left-container {
    width: 288px;
    padding: 16px;
    box-sizing: border-box;
    border-right: 1px solid $bg-ShallowLightSnow;
  }
  .right-container {
    flex: 1;
    padding: 16px 20px 0px 20px;
    .top-container {
      @include flex-between;
      border-bottom: 1px solid $bg-ShallowLightSnow;
      .add {
        width: 80px;
        margin-bottom: 8px;
        .el-button {
          padding: 0;
        }
      }
      .tab {
        flex: 1;
        flex-wrap: wrap;
        overflow-x: auto;
        @include flex-start;
        margin-bottom: 8px;
        .tab-item {
          width: 72px;
          height: 32px;
          line-height: 32px;
          font-weight: 400;
          margin-right: 10px;
          border-radius: 2px;
          color: $color-grey;
          font-size: $fs-small-l;
          cursor: pointer;
        }
        .active {
          background: $bg-Tab;
          color: $color-ChangeDepartmentHighTree;
        }
      }
    }
    .container {
      padding: 28px 0px;
      margin-bottom: 80px;
      .sub-title {
        color: $color-Step;
        font-size: $fs-medium-s;
        border-left: 4px solid $bg-DeepReddishBlue;
        text-align: left;
        padding-left: 5px;
        margin-bottom: 22px;
      }
      .condition {
        color: $color-Step;
        font-size: $fs-small-l;
        text-align: left;
        padding-left: 24px;
        margin-bottom: 20px;
      }
      .condition-row {
        @include flex-start;
        padding-left: 56px;
        span {
          width: 80px;
          font-size: $fs-small-l;
          color: $color-FinancialAudit;
        }
      }
      .row {
        padding-left: 38px;
        margin-bottom: 25px;
        .step {
          @include flex-start;
        }
        .step-num-default {
          width: 40px;
          height: 40px;
          line-height: 40px;
          margin-right: 22px;
        }
        .step-num {
          width: 40px;
          height: 40px;
          line-height: 40px;
          margin-right: 22px;
          color: $color-white;
          background: url("../assets/step.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
        .active {
          width: 40px;
          height: 40px;
          line-height: 40px;
          margin-right: 22px;
          color: $color-BlackGrey;
          background: url("../assets/gray.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
        .stepActive {
          color: $color-LightGrey;
        }
        .step-main {
          flex: 1;
          min-height: 56px;
          @include flex-between;
          background: $bg-StepMain;
          padding: 0px 20px;
          font-size: $fs-medium-s;
          font-weight: 400;
          color: $color-Step;
          .step-main-right {
            color: $color-MainRight;
            cursor: pointer;
            width: 40px;
          }
          .operation-btn {
            display: flex;
            .step-main-right {
              margin-left: 20px;
            }
            .del {
              color: $color-Crimson;
            }
          }
        }
        .step-main-agent {
          text-align: left;
          padding: 10px 20px;
          line-height: 20px;
          box-sizing: border-box;
          &-left {
            flex: 1;
            @include flex-start;
            &-title {
              display: inline-block;
              width: 70px;
              text-align: left;
            }
            &-content {
              flex: 1;
            }
          }
        }
        .financial-audit {
          height: 55px;
          line-height: 55px;
          margin-left: 62px;
          background: $bg-white;
          padding: 0px 20px;
          font-size: $fs-small-l;
          font-weight: 400;
          color: $color-FinancialAudit;
          border: 1px solid $bg-ShallowLightSnow;
          border-top: none;
          @include flex-start;
          .financial-title {
            margin-right: 30px;
          }
          .el-radio__label {
            color: $color-FinancialAudit;
          }
        }
      }
      .evection {
        margin-bottom: 22px
      }
      .evection-title {
        @include flex-between;
        padding-right: 18px;
      }
      .evection-row {
        @include flex-start;
        padding-left: 38px;
        .evection-row-center {
          margin: 0px 12px;
        }
        .evection-row-container {
          width: 23%;
          height: 110px;
          box-sizing: border-box;
          background: $bg-StepMain;
          border: 1px solid $bg-WhiteSmoke;
          padding: 0px 10px;
        }
        .el-icon-circle-plus-outline {
          font-size: 32px;
          cursor: pointer;
          color: $color-FinancialAudit;
        }
        .evection-agent {
          height: 56px;
          line-height: 56px;
          text-align: left;
          border-bottom: 1px solid $bg-ShallowLightSnow;
          font-size: $fs-medium-s;
          font-weight: 400;
          color: $color-FinancialAudit;
        }
        .evection-row-content {
          @include flex-start;
          height: 54px;
          font-size:  $fs-medium-s;
          font-weight: 400;
          color:$color-Step;
          .evection-img {
            width: 22px;
            height: 22px;
            margin-right: 10px;
          }
        }
        .evection-row-approval {
          width: 25.6%;
          @include flex-start;
          .evection-row-approval-content {
            width: 100%;
            height: 110px;
            box-sizing: border-box;
            background: $bg-StepMain;
            border: 1px solid $bg-WhiteSmoke;
            padding: 0px 10px;
            position: relative;
            .el-icon-error {
              position: absolute;
              right: -8px;
              top: -8px;
              cursor: pointer;
            }
          }
        }
      }
    }
    .foot-container {
      width: calc(100% - 545px);
      box-sizing: border-box;
      height: 64px;
      @include flex-start;
      position: fixed;
      right: 37px;
      bottom: 0;
      padding-left: 30px;
      background: $bg-white;
      box-shadow: 0px -4px 8px 0px rgba(31, 31, 31, 0.06);
    }
  }
  .dialog-content {
    margin: 20px;
    background: $bg-ChangeDepartmentTree;
    .department-people {
      height: 40px;
      line-height: 40px;
      padding-left: 21px;
      text-align: left;
      font-size: $fs-small-l;
      font-weight: 400;
      color: $bg-grey;
      &:hover {
        color: $color-DepartmentPeople;
        background: $bg-ChangeDepartmentHighTree;
      }
    }
    .departmentActive {
      color: $color-DepartmentPeople;
      background: $bg-ChangeDepartmentHighTree;
    }
  }
  
  .el-form-item.is-required:not(.is-no-asterisk)
    .el-form-item__label-wrap
    > .el-form-item__label:before,
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    display: none;
  }
  .el-form-item.is-required:not(.is-no-asterisk)
    .el-form-item__label-wrap
    > .el-form-item__label:before,
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label::after {
    content: "*";
    color: $bg-Required;
    margin-left: 4px;
  }
  .nothing {
    position: absolute;
    left: 60%;
    top: 50%;
    @include flex-center;
    img {
      width: 157px;
      height: 157px;
    }
    p {
      font-size: $fs-small-l;
      font-weight: 400;
      color: $color-LightGrey;
      margin-top: 24px;
    }
  }
}
</style>
